import { ReactNode } from 'react'

interface ISettingsSectionProps {
    title: string
    description?: string
    cta?: ReactNode
    children?: ReactNode
}

export const SettingsSection = ({ title, description, cta, children }: ISettingsSectionProps) => {
    return (
        <div className="flex flex-col gap-4">
            <div className="flex items-start justify-between gap-4">
                <div>
                    <h3 className="text-[16px] font-semibold text-[#171717]">{title}</h3>
                    {description && <p className="text-[13px] text-[#6B7280] mt-1">{description}</p>}
                </div>
                {cta && <div className="shrink-0">{cta}</div>}
            </div>
            {children}
        </div>
    )
}
